angular.module('rjmNg.services').factory 'encodedLetterString', [() ->
  asciiBase = 65
  numberOfLetters = 26

  # Made this private since @ becomes global sometimes when calling it from the restrictionSetDirective
  _numToLetter = (number) ->
    if number < 26
      return String.fromCharCode(number + asciiBase)
    return _numToLetter((Math.floor(number / numberOfLetters) - 1)) + _numToLetter((number % numberOfLetters))

  _addBraces = (value) ->
    "[#{value}]"

  # Public interface to the private numToLetter function, since it gets called directly by a few controllers now
  numToLetter:  (number) ->
    if number < 0 or not _(number).isNumber()
      throw "Invalid Number for Conversion to Letter: " + number
    return _numToLetter(number)

  indexToAlpha: (index, includeBraces=true) ->
    if index < 0 or not _(index).isNumber()
      throw "Invalid Index for Conversion to Alpha: " + index

    val = _numToLetter(index)
    if includeBraces then _addBraces(val) else val

  alphaToIndex: (chr) ->
    strippedString = chr.replace(/\[|\]/g, "") #get rid of the brackets
    value = 0
    i = 0
    while i < strippedString.length
      power = (strippedString.length - i) - 1
      index = (strippedString.charCodeAt(i) - asciiBase) + 1
      value += index * Math.pow(numberOfLetters, power)
      i++
    return value - 1

  swapValues: (string, fromIndex, toIndex) ->
    return string.replace(@indexToAlpha(fromIndex), @indexToAlpha(toIndex))
]
